/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

import React from 'react'

import { Badge, Checkbox, Tooltip } from '@/components/ui'
import type { CatalogueInsight } from '@/insights/insightCatalogue'

import { cappedTooltip, isInsightCapped } from './capRules'
import type { PermissionsCap } from './types'
import type { UsageCount } from './usage'

interface Props {
  insight: CatalogueInsight
  checked: boolean
  onChange: (checked: boolean) => void
  cap: PermissionsCap | null
  used: UsageCount
  inUseLabel: (count: UsageCount) => string
  disabled?: boolean
}

export const InsightRow: React.FC<Props> = ({ insight, checked, onChange, cap, used, inUseLabel, disabled }) => {
  const capped = isInsightCapped(cap, insight.slug)
  const checkbox = (
    <Checkbox
      id={`insight-${insight.slug}`}
      data-testid={`insight-${insight.slug}`}
      label={insight.name}
      checked={checked}
      disabled={disabled || capped}
      onChange={onChange}
      trailing={
        used.users > 0 ? (
          <Badge variant="info" size="xs">
            {inUseLabel(used)}
          </Badge>
        ) : undefined
      }
    />
  )
  return capped && cap ? (
    <Tooltip tip={cappedTooltip(insight.name, cap.companyName)} position="right">
      {checkbox}
    </Tooltip>
  ) : (
    checkbox
  )
}

export default InsightRow
